import MultiSelect from '@shared/component/MultiSelect';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { IoMdAdd } from 'react-icons/io';
import { MdDeleteOutline } from 'react-icons/md';

export function DemandAddMidLocation(props: any) {
    const getSeletedVal = () => {
        try {
            if (props.edit && props.editDemandTransporter?.midLocationIdArray) {
                const data = props.editDemandTransporter?.midLocationIdArray.filter(i => i.id == props.d.id);
                return data?.length ? data[0] : null;
            } else {
                return null;
            }
        } catch (error) {
            return null;
        }
    };

    return (
        <>
            <div className="col-sm-6">
                <MultiSelect
                    isSingle={true}
                    options={props.locationData}
                    placeholder={'In Between Stop'}
                    getMultiSelectValue={e => props.getValueMidLocation(e, props.index, props.d.id)}
                    displayName="fullcity"
                    displayValue="id"
                    isClearable={!props.edit}
                    notSelectDefault={true}
                    isDisabled={props.statusCompleted === 'completed'}
                    setSelectedValues={getSeletedVal()}
                // setSelectedValues={
                //     props.edit && props.editDemandTransporter?.midLocationId
                //         ? props.editDemandTransporter?.midLocationId[props.index] || null
                //         : null
                // }
                />
            </div>
            <div className="col-sm-6">
                {props.index > 0 ? (
                    props.statusCompleted == 'completed' ? (
                        ''
                    ) : (
                        <Button
                            variant=""
                            onClick={() => props.removeMultiSelect(props.d.id, props.index)}
                            className="ml-2"
                        >
                            <MdDeleteOutline size={25} />
                        </Button>
                    )
                ) : props.statusCompleted == 'completed' ? (
                    ''
                ) : !props.disbleAddBtn && props.locationData?.length > 0 ? (
                    <>
                        {
                            props.edit &&
                            <Button
                                variant=""
                                onClick={() => props.removeMultiSelect(props.d.id, props.index)}
                                className="ml-2"
                            >
                                <MdDeleteOutline size={25} />
                            </Button>
                        }
                        <Button variant="secondary" size="sm" onClick={props.addMultiSelect}>
                            <IoMdAdd /> Add
                        </Button>
                    </>
                ) : (
                    ''
                )}
            </div>
        </>
    );
}



